export enum MandatorDictionaries {
  Kiosks = 'Kiosks',
}
